import { createAtomObserver } from '@exodus/atoms';
const createExchangePlugin = (params) => {
    const { exchangeModule, exchangeProviders, exchangeAvailability, exchangeAssetAvailability, exchangeStatusAtom, exchangeAvailabilityAtom, exchangeableAssetsAtom, port, } = params;
    const atomObservers = [
        createAtomObserver({ atom: exchangeStatusAtom, port, event: 'exchangeStatus' }),
        createAtomObserver({ atom: exchangeAvailabilityAtom, port, event: 'exchangeAvailability' }),
        createAtomObserver({ atom: exchangeableAssetsAtom, port, event: 'exchangeableAssets' }),
    ];
    atomObservers.forEach((atomObserver) => atomObserver.register());
    const onLoad = () => {
        exchangeModule.load();
        exchangeProviders.load();
        exchangeAvailability.load();
        exchangeAssetAvailability.load();
        atomObservers.forEach((atomObserver) => atomObserver.start());
    };
    const onStart = () => {
        void exchangeAssetAvailability.start();
    };
    const onStop = () => {
        exchangeModule.stop();
        exchangeProviders.stop();
        exchangeAvailability.stop();
        exchangeAssetAvailability.stop();
        atomObservers.forEach((atomObserver) => atomObserver.unregister());
    };
    return { onLoad, onStart, onStop };
};
const exchangePluginDefinition = {
    id: 'exchangePlugin',
    type: 'plugin',
    factory: createExchangePlugin,
    dependencies: [
        'exchangeModule',
        'exchangeProviders',
        'exchangeAvailability',
        'exchangeStatusAtom',
        'exchangeAvailabilityAtom',
        'exchangeableAssetsAtom',
        'exchangeAssetAvailability',
        'port',
    ],
    public: true,
};
export default exchangePluginDefinition;
